import { Component, Input } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { SmTimer } from 'src/modules/sm-base/models/sm-timer.model';
import { DhTools } from '../../models/dh-tools.model';

@Component({
  selector: 'app-document-handler-stack-trace',
  templateUrl: './document-handler-stack-trace.component.html',
  styleUrl: './document-handler-stack-trace.component.scss'
})
export class DocumentHandlerStackTraceComponent extends ComponentView {

    @Input()
    guid: string = null;

    _useTimer = false;
    
    stackTrace: string;

    @Input()
    set useTimer(value: boolean) {
        if (value == this._useTimer) {
            return;
        }
        this._useTimer = value;
       /* if (this._useTimer) {
            this.addTimer(new SmTimer(0, 1_000, this.update.bind(this)));
        }
        else {
            throw new Error("Timer entfernen nicht implmementiert");
        }*/
    }

    async initParams(): Promise<boolean> {
        if (this._useTimer) {
            this.addTimer(new SmTimer(1000, 1000, this.update.bind(this), true));
        }
        return Promise.resolve(true);
    }

    async update(): Promise<void> {
      this.stackTrace = await DhTools.backendCall("api/dhinstance/getStackTrace", { instanceGuid: this.guid }).getString();
    }
}
